export default "/images/AylinAnik.jpg?d8b620ea454eb3d16db0a3fe54e31f4b";